
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public Seleccionado: number = 0;
        public Cargando: string = 'ninguno';

        public Items: { Id?: string, Tipo: 'opcion' | 'titulo'; Icono?: string; Titulo?: string; Accion?: Function; }[] = [

            { Id: "si", Tipo: 'opcion', Icono: 'check', Titulo: 'Si', Accion: this.Si },
            { Id: "no", Tipo: 'opcion', Icono: 'close', Titulo: 'No', Accion: this.No },
        ];

        No()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }

        async Si( item: string )
        {
            this.Cargando = item;
            if ( this.Controlador.Pedido && this.Controlador.Pedido.Existe )
            {
                if ( this.Controlador.Pedido.saveEstado( Pedidos.Estados.Cancelado ) )
                {
                    Utiles.Notificaciones.Info( 'Pedido cancelado.' );
                    this.Controlador.Reiniciar();
                    this.Cerrar();
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al cancelar el pedido.' );
                }
            }
            this.Cargando = 'ninguno';

        }


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }
        created()
        {
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            this.Eventos.push( Utiles.onKeyDown.subscribe( e => this.onKeyDown( e ) ) );
        }

        onKeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter', 'Tab', 'F3', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }

        onKeyUp( e: KeyboardEvent )
        {
            if ( this.Cargando != 'ninguno' ) return;

            if ( e.key == 'ArrowUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado - 1 );
            }
            else if ( e.key == 'ArrowDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado + 1 );
            }
            else if ( e.key == 'PageUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( 0 );
            }
            else if ( e.key == 'PageDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Items.filter( x => x.Tipo == 'opcion' ).length - 1 );
            }
            else if ( e.key == 'Escape' )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado] )
                {
                    this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Accion();
                }
            }
        }

        public SeleccionarLista( x: number )
        {
            if ( this.Items.filter( x => x.Tipo == 'opcion' )[x] )
            {
                this.Seleccionado = x;
                //if ( !this.isVisibleLista( this.Seleccionado ) )
                this.ScrollToItemLista();
            }
        }

        protected ScrollToItemLista()
        {
            let element = document.getElementById( 'barra-izquierda-lista' );
            let element2 = document.getElementById( 'barra-izquierda-lista-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 20,
                duration: 0,
            } );
        }

        protected isVisibleLista( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }
        Cerrar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }


    }
